import { useQuery } from '@tanstack/react-query';
import { financialSummaryService } from '../services/apiServices';

export const useFinancialSummary = (year?: number) => {
  return useQuery({
    queryKey: ['financialSummary', year],
    queryFn: () => financialSummaryService.getMonthly(year ? { year } : undefined),
  });
};
